import {
  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE
} from 'Constants/'

import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import { pendoTrack } from 'Helpers/pendoTracking'

import {
  getFilterDetails,
  setEnableWorkflow
} from 'Pages/Workflow/recoil/actions/actions'
import { workflowDetails } from 'Pages/Workflow/recoil/state/data'
import { modalActivateSimulateState } from 'Pages/Workflow/recoil/state/modalActivateSimulate'
import {
  modalFilterDetailsState,
  modalWelcomeReactivationState
} from 'Pages/Workflow/recoil/state/modals'
import { pageState } from 'Pages/Workflow/recoil/state/page'

export const toggleEnabledCallback =
  ({ set, snapshot }) =>
  async () => {
    //  WelcomeSeries
    const { Id, Enabled, Type } = await snapshot.getPromise(workflowDetails)
    const { WelcomeMsgEnabled } = await snapshot.getPromise(pageState)

    if (
      Type === OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE &&
      !WelcomeMsgEnabled
    ) {
      set(modalWelcomeReactivationState, (prev) => ({ ...prev, show: true }))
    } else if (
      !Enabled &&
      Type === OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE
    ) {
      set(modalActivateSimulateState, {
        mode: 'activate',
        show: true
      })
    } else {
      set(pageState, (prev) => ({
        ...prev,
        loading: true
      }))

      try {
        setEnableWorkflow(Id, !Enabled)
        if (!Enabled) {
          pendoTrack('Workflow Active', {})
        }

        set(workflowDetails, (prev) => ({ ...prev, Enabled: !Enabled }))
      } catch (error) {
        logAppError({
          Component: 'Workflow',
          Method: 'step1ToStep2Callback',
          appError: error
        })
        set(pageState, (prev) => ({
          ...prev,
          error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
          severity: 'danger'
        }))
      }

      set(pageState, (prev) => ({
        ...prev,
        loading: false
      }))
    }
  }

export const filterDetailsCallback =
  ({ set }) =>
  async (filterId) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))

    try {
      const { Id, Type, Name, Description } = await getFilterDetails(filterId)

      set(modalFilterDetailsState, (prev) => ({
        ...prev,
        show: true,
        id: Id,
        type: Type,
        name: Name,
        description: Description,
        canEdit: [
          'Anagraphic',
          'Activity',
          'Geolocation',
          'Engagement'
        ].includes(Type)
      }))
    } catch (error) {
      logAppError({
        Component: 'Workflow',
        Method: 'filterDetailsCallback',
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))
  }

//
export const activateCallback =
  ({ reset, set, snapshot }) =>
  async () => {
    //  WelcomeSeries
    const { Id, Enabled } = await snapshot.getPromise(workflowDetails)

    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))

    try {
      setEnableWorkflow(Id, !Enabled)
      if (!Enabled) {
        pendoTrack('Workflow Active', {})
      }

      set(workflowDetails, (prev) => ({ ...prev, Enabled: !Enabled }))
      reset(modalActivateSimulateState)
    } catch (error) {
      logAppError({
        Component: 'Workflow',
        Method: 'activateCallback',
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))
  }
